import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'expire',
  templateUrl: './expire.component.html'
})

export class ExpireComponent implements OnInit {
 ngOnInit(): void {
    
  }
}
